import { Box } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';

import Video from 'UiKit/video';

import styles from './styles.module.css';

const OpenCamera = ({ className, isOpen, facingMode = 'user', setIsCameraReady, onPermissionDenied }) => {
  const streamRef = useRef();

  const handleCloseCamera = () => {
    streamRef?.current?.getTracks().forEach((track) => track.stop());
    setIsCameraReady?.(false);
  };

  const handleOpenCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          facingMode,
          frameRate: { ideal: 30, max: 30 },
        },
      });

      const video = document.getElementById('video-stream');
      streamRef.current = stream;
      video.srcObject = stream;
      video.onloadedmetadata = () => {
        video?.play();
        if (video.videoWidth > 0 && video.videoHeight > 0) setIsCameraReady?.(true);
      };
    } catch (error) {
      if (error.name === 'NotAllowedError') onPermissionDenied?.();
    }
  };

  useEffect(() => {
    setIsCameraReady?.(false);
    if (isOpen) handleOpenCamera();

    return () => handleCloseCamera();

    /* eslint-disable-next-line */
  }, [isOpen, facingMode]);

  return (
    <Box className={styles['camera__container']}>
      <Video className={className} id="video-stream" playsInline autoPlay muted />
    </Box>
  );
};

export default OpenCamera;
